import React, { useCallback } from "react";
import styled from "styled-components";
import NewRouteForm from "./NewRouteForm";
import { AmeaCategorySingularName } from "../helpers";
import * as Icon from "../smartiscity/Icons";

const DataList = ({
  data,
  showNewRouteForm,
  mapData,
  rightSideBox,
  categoryId,
  selectedCategory,
  selectedItem,
}) => {
  const listItemIcon = (icon) => (
    <i
      className={`im ${icon}`}
      style={{ fontSize: "30px", float: "left", color: "inherit" }}
    ></i>
  );

  const renderMeteoIcons = useCallback((items, key) => {
    return items?.map((item, id) => (
      <img
        key={`${key}_icon_${id}`}
        src={`https://alexandria.smartiscity.gr/gallery/vars/Small/${item.sensorvar_icon}`}
        alt={item.sensorvar_icon}
      />
    ));
  }, []);

  const handleItemClick = useCallback(
    (item) => {
      const rightSideMap = {
        5: true,
        24: true,
        31: false,
        122: selectedCategory === "infra" ? false : !showNewRouteForm.get,
      };

      if (rightSideMap[categoryId]) {
        if (!rightSideBox.isVisible) {
          rightSideBox.setIsVisible(true);
        }
      }
      selectedItem.setItem(item);
    },
    [selectedCategory, showNewRouteForm.get, categoryId]
  );

  const renderDataItem = useCallback(
    (item, index) => {
      const itemContent = {
        5: () => (
          <RenderDataItemContainer>
            {listItemIcon("im-icon-Cloud-Sun")}
            <RenderDataItemContent>
              <p style={{ fontWeight: "500" }}>{item.mysensor_name}</p>
              <p style={{ fontSize: "14px" }}>{item.sensor_address}</p>
              <div>{renderMeteoIcons(item.details, item.mysensor_name)}</div>
            </RenderDataItemContent>
          </RenderDataItemContainer>
        ),
        24: () => (
          <RenderDataItemContainer>
            {listItemIcon("im-icon-Car-2")}
            <RenderDataItemContent>
              <p style={{ fontWeight: "600" }}>Θέση {item.LabelOnStreet}</p>
              <p style={{ fontSize: "14px" }}>{item.address}</p>
              {/* <div>{renderMeteoIcons(item.details, item.mysensor_name)}</div> */}
            </RenderDataItemContent>
          </RenderDataItemContainer>
        ),
        31: () => (
          <RenderDataItemContainer>
            {listItemIcon("im-icon-Monitor-Vertical")}
            <RenderDataItemContent>
              <p style={{ fontWeight: "500" }}>{item.mysensor_name}</p>
              <p style={{ fontSize: "14px" }}>{item.sensor_address}</p>
              {item?.metrics && (
                <p style={{ fontSize: "14px" }}>
                  <span style={{ fontWeight: "500", marginRight: "5px" }}>
                    {item?.metrics[0]?.content}:
                  </span>
                  {item?.metrics[0]?.value}
                </p>
              )}
            </RenderDataItemContent>
          </RenderDataItemContainer>
        ),
        122: () => (
          <>
            <img src={Icon.defaultRoutes} alt="Default Route" />
            {selectedCategory === "infra" ? (
              <div>
                <p>{`${AmeaCategorySingularName(item.category)} (${
                  item.title
                })`}</p>
                <p>{`${item.type}ς Χρήσης`}</p>
              </div>
            ) : (
              <div>
                <p>{item.title}</p>
                <p style={{ fontSize: "14px" }}>{item.category}</p>
                <p style={{ fontSize: "14px" }}>Απόσταση: {item.distance} m</p>
              </div>
            )}
          </>
        ),
      };

      return (
        <LeftSideItemContainer
          key={`${categoryId}_item_${index}`}
          $selectedItemId={
            selectedItem.getItem?.id ?? selectedItem.getItem?.mysensor_id
          }
          $itemId={item.id ?? item.mysensor_id}
          onClick={() => handleItemClick(item)}
        >
          {itemContent[categoryId]?.() ?? <p>Item {index}</p>}
        </LeftSideItemContainer>
      );
    },
    [
      categoryId,
      selectedCategory,
      handleItemClick,
      renderMeteoIcons,
      selectedItem,
    ]
  );

  const renderData = useCallback(() => {
    return data?.length > 0 ? data.map(renderDataItem) : [];
  }, [data, renderDataItem]);

  return (
    <LeftSideData>
      {showNewRouteForm.get ? (
        <NewRouteForm showNewRouteForm={showNewRouteForm} mapData={mapData} />
      ) : (
        renderData()
      )}
    </LeftSideData>
  );
};

export default DataList;

const LeftSideData = styled.div`
  width: 100%;
`;

const RenderDataItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

const RenderDataItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const LeftSideItemContainer = styled.div`
  width: 100%;
  background-color: ${(props) =>
    props.$selectedItemId === props.$itemId ? "rgba(0, 0, 0, 0.1)" : "unset"};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  padding: 20px 30px;
  &:hover {
    background-color: rgba(0, 0, 0, 0.2);
  }
`;
